import { render, staticRenderFns } from "./indexIframe.vue?vue&type=template&id=afd08ac2&scoped=true&"
import script from "./indexIframe.vue?vue&type=script&lang=js&"
export * from "./indexIframe.vue?vue&type=script&lang=js&"
import style0 from "./indexIframe.vue?vue&type=style&index=0&id=afd08ac2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd08ac2",
  null
  
)

export default component.exports